// taken from https://stackoverflow.com/a/63627688/5472574
const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};

const Report = ({ link }) => {
  return (
    <div className="card border-light shadow mt-3">
      <img
        src="/hadays.png"
        className="card-img-top"
        alt="histogram placeholder"
      ></img>
      <div className="card-body">
        <h5 className="card-title">Download Report</h5>
        <p className="card-text">
          Click to download the patient's data log analysis.
        </p>
        <button
          className="btn btn-lg btn-primary"
          onClick={() => openInNewTab(link)}
        >
          Download
        </button>
      </div>
    </div>
  );
};

export default Report;
